import { render, staticRenderFns } from "./video-play-model.vue?vue&type=template&id=acf2710e&scoped=true"
import script from "./video-play-model.vue?vue&type=script&lang=ts"
export * from "./video-play-model.vue?vue&type=script&lang=ts"
import style0 from "./video-play-model.vue?vue&type=style&index=0&id=acf2710e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf2710e",
  null
  
)

export default component.exports